<template>
  <div class="tac">
    <div class="login-wrapper">
      <div class="login-header">
        <div class="logo">
          <img src="../assets/images/logo.png" alt="">
        </div>
        <div>UA HOUSE后台管理系统</div>
      </div>
      <div class="login-bg">
        <div class="login-container">
          <div id="wx_reg" v-loading="loading" element-loading-text="loading" />
        </div>
      </div>
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        class="form"
        @submit.native.prevent
      >
        <el-form-item prop="email">
          <el-input
            v-model="form.email"
            name="email"
            auto-complete="on"
            placeholder="请输入电子邮箱"
          />
        </el-form-item>
        <el-form-item>
          <el-button style="width: 100%" type="primary" @click="login('form')">继续</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
import { validation } from "../api/user";
import { mapMutations } from "vuex";
import { validEmail } from "../utils/validate";
import Cookies from "js-cookie";
export default {
  data() {
    var checkEmail = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入电子邮箱"));
      }
      setTimeout(() => {
        if (validEmail(value)) {
          callback();
        } else {
          callback(new Error("请输入正确的邮箱格式"));
        }
      }, 100);
    };
    return {
      loading: false,
      form: {
        email: "",
      },
      rules: {
        email: [{ validator: checkEmail, trigger: "blur" }],
      },
    };
  },
  methods: {
    ...mapMutations(["setUser"]),
    login(formName) {
      const that = this;
      this.$refs[formName].validate(valid => {
        if (valid) {
          console.log(process.env.NODE_ENV);
          // 开发环境
          if (process.env.NODE_ENV === "development") {
            const query = that.$route.query;
            Cookies.set(
              "token",
              "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MiwiaWF0IjoxNzYyODQ2NDE0fQ.4ShpRKpBgQLoO3uIXWbdZCR1kJ0cJi-6zg4ywVaqUu8"
            );
            Cookies.set("email", "fox.yang@underarmour.com");
            Cookies.set("name", "Fox.Yang");
            that.$router.push(
              query.redirect ? { path: `${query.redirect}` } : { path: "/" }
            );
          } else {
            validation(this.form).then(() => {
              window.open(
                `${process.env.VUE_APP_BASE_API}saml/pre-login?email=${this.form.email}`,
                "_self"
              );
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>
<style lang="less">
.cycle-count_title {
  margin: 20px 0;

  font-size: 24px;
}

.login-wrapper {
  width: 410px;
  min-height: 500px;

  text-align: center;

  background: #fff;
}

.tac {
  display: flex;
  align-items: center;
  justify-content: center;

  height: 100vh;

  background: #fff;
  background-repeat: no-repeat;
  background-position: left center;
  background-size: auto 100%;
}

.login-bg {
  flex: 1;
}

.login-header {
  overflow: hidden;

  width: 100%;

  background-color: #fff;
  .logo {
    width: 200px;
    padding: 20px 0 10px 0;
    img {
      width: 100%;
    }
  }
}

.login-header {
  overflow: hidden;

  width: 100%;

  background-color: #fff;
  > div:nth-child(2) {
    margin-top: 15px;

    font-size: 24px;
  }
  .logo {
    width: 150px;
    margin: auto;
    padding: 20px 0 10px 0;
    img {
      width: 100%;
    }
  }
}
.form {
  margin-top: 50px;
}
</style>
